<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="20" style="text-align: left;display: flex;align-items: center;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item label="商机进度：" size="medium">
                                <el-button size="mini" :class="{'selected':form.businessProgId==null}" @click="handleSearchType(null)">全部</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.businessProgId==1}" @click="handleSearchType(1)">初步接洽</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.businessProgId==2}" @click="handleSearchType(2)">需求确认</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.businessProgId==3}" @click="handleSearchType(3)">意向发单</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.businessProgId==4}" @click="handleSearchType(4)">已赢单</el-button>
                                <el-button size="mini" style="margin-left: 25px;" :class="{'selected':form.businessProgId==5}" @click="handleSearchType(5)">已输单</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4" style="text-align: right;">
                    <template v-if="!(typeof(actionData.customersjlb_add) != 'undefined'&&!actionData.customersjlb_add)">
                        <el-button size="medium" type="primary" icon="el-icon-plus" @click="handleOpen">添加</el-button>
                    </template>
                </el-col>
            </el-row>
        </div>
        <el-form inline label-width="90px" label-position="left" style="padding: 20px 14px 0 14px;">
            <el-form-item label="分类：">
                <el-select size="medium" v-model="stateType" placeholder="请选择" @change="handleSearchSelect">
                    <el-option :value="1" label="全部"></el-option>
                    <el-option :value="2" label="我的"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>
         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="590"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="商机名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.businessName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span class="linkInfo" v-if="scope.row.businessName" @click="linkDealerInfoFun(scope.row.pkid)">{{scope.row.businessName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="领域">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            placeholder="请选择" 
                            size="mini"
                            v-model="form.domainId" 
                            style="width: 100%"
                            @change="getOptionServiceStage"
                        >
                            <el-option 
                                v-for="(item,index) in domianList"
                                :value="item.domainid" 
                                :label="item.domainname" 
                                :key="index" 
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.domain || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="项目类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            v-model="form.serviceStageId" 
                            placeholder="请选择" 
                            style="width: 100%;"
                        >
                            <el-option 
                                v-for="(item,index) in serviceStageList"
                                :value="item.servicestageid" 
                                :label="item.servicestagename" 
                                :key="index" 
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.serviceStageName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="对应客户">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.custName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span class="linkInfo" v-if="scope.row.custName" @click="linkCustomerInfoFun(scope.row.companyId,scope.row.custId)">{{scope.row.custName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="预计成单日期" >
                <el-table-column show-overflow-tooltip width="240">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.preOrderDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        >
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.preOrderDate || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="预计成单金额">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.preOrderAmount" placeholder="<="/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.preOrderAmount || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            
            <el-table-column label="负责人" v-if="stateType==1">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini"
                            filterable
                            v-model="form.principalId" 
                            placeholder="请选择"
                        >
                            <el-option 
                                v-for="(item,index) in fzrList"
                                :label="item.userName" 
                                :value="item.userId"
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.principal || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="商机进度">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.businessProgId" placeholder="请选择">
                            <el-option :value="1" label="初步接洽"></el-option>
                            <el-option :value="2" label="需求确认"></el-option>
                            <el-option :value="3" label="意向发单"></el-option>
                            <el-option :value="4" label="已赢单"></el-option>
                            <el-option :value="5" label="已输单"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.businessProg || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="下次跟进日期" >
                <el-table-column show-overflow-tooltip width="240">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.nextTraceDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        >
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.nextTraceDate || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <AddDialog ref="addDealer" @onSubmit="confirmDealerAdd"/>
    </div>
</template>
<script>
import { getStorageUserRoleId, getActionData } from '@/utils/store'
import {
        businessList,   //商机列表
        optionHeaders,  //负责人
        prodDomains,    //获取领域
        optionServiceStage, //项目类型（服务类型）
        addBusinessOrModi,          //新增|修改
    } from "@/service/customerInformation";
import AddDialog from './index/addDealerDialog'
    export default {
        components: {
            AddDialog
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                stateType: 1,           //转台 1全部 2我的
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,

                    businessName: '',   //商机名称
                    domainId: '',       //领域
                    serviceStageId: '',   //项目类型

                    custName: '',       //对应客户
                    preOrderDate: [],   //预计成单日期
                    preOrderAmount: '', //预计成单金额
                    principalId: '',    //负责人id
                    businessProgId: '', //商机进度
                    nextTraceDate: [],   //预计成单日期
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数

                
                tableData:[],
                fzrList: [],        //负责人
                domianList: [],     //领域
                serviceStageList: [],   //项目（服务）列表
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.getOptionHeaders();
            this.getProdDomains();
        },
        methods: {
            // 1全部 2我的 
            handleSearchSelect(){
                if(this.stateType == 2) {
                    this.form.principalId = getStorageUserRoleId()
                    this.searchData.principalId = getStorageUserRoleId()
                }else{
                    this.form.principalId = ''
                    this.searchData.principalId = ''
                }
                this.handleSearch();
            },
            // 获取领域
            getProdDomains(){
                prodDomains().then(res=>{
                    this.domianList = res.Data
                })
            },
            // 获取项目类型(通过领域id)
            getOptionServiceStage(){
                this.serviceStageList = []
                this.form.serviceStageId = ''
                let data = {
                    domainId: this.form.domainId
                }
                optionServiceStage(data).then(res=> {
                    this.serviceStageList = res.Data
                })
            },
            // 商机进度
            handleSearchType(type){
                this.form.businessProgId = type
                this.handleSearch()
            },
            // 获取负责人
            getOptionHeaders() {
                let data = {}
                data.headerType = 1
                optionHeaders(data).then(res=> {
                    this.fzrList = res.Data;
                })
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.stateType = 1
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetbusinessList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetbusinessList()
            },
            //获取我的客户列表
            async GetbusinessList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                data.rational = true
                !data.businessName && delete data.businessName
                !data.domainId && delete data.domainId
                !data.serviceStageId && delete data.serviceStageId
                !data.custName && delete data.custName
                if (data.preOrderDate && data.preOrderDate.length) {
                    data.preOrderDateBegin = data.preOrderDate[0] + ' 00:00:01'
                    data.preOrderDateEnd = data.preOrderDate[1] + ' 23:59:59'
                }
                if (data.nextTraceDate && data.nextTraceDate.length) {
                    data.nextTraceDateBegin = data.nextTraceDate[0] + ' 00:00:01'
                    data.nextTraceDateEnd = data.nextTraceDate[1] + ' 23:59:59'
                }
                !data.preOrderAmount && delete data.preOrderAmount
                !data.principalId && delete data.principalId
                !data.businessProgId && delete data.businessProgId
                delete data.preOrderDate;
                delete data.nextTraceDate;
                let res = await businessList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas
                this.total = res.Data.total
            },
            // 跳转到商机信息
            linkDealerInfoFun(id) {
                this.$router.push('/customer/dealerInfo?pkid='+ id)
            },
            // 跳转到客户信息
            linkCustomerInfoFun(id,custId) {
                this.$router.push('/customer/dealerCustomerInfo?companyId='+ id +'&custId='+custId)
            },

            // 添加按钮
            confirmDealerAdd(val) {
                addBusinessOrModi(val).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('添加成功！')
                    this.$refs.addDealer.editorClose()
                    this.GetbusinessList();
                })
            },
            // 点击新增
            handleOpen(){
                console.log(111)
                this.$refs.addDealer.open()
            },
            handleClick(tab, event) {
                console.log(tab);
                console.log(event);
            }
        }
    };
</script>
<style  lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .linkInfo {
        cursor: pointer;
        &:hover {
            color: #409EFF;
        }
    }
</style>